import { BackgroundFloatingBoxes } from "components/BackgroundFloatingBoxes"
import DemoNavbar from "components/Navbars/DemoNavbar"
import EstimatedDeliveryDatesDisplay from "./EstimatedDeliveryDatesDisplay"
// reactstrap components
import {
    Container,
    Row,
    Col,
    CardImg
} from "reactstrap";
import React from "react";
import CardsFooter from "components/Footers/CardsFooter";
import TrialCallout from "components/TrialCallout";
import { Helmet } from "react-helmet";
import { EstimatedDeliveryDateProductCardDemo } from "./EstimatedDeliveryDateProductCardDemo";
import { getDemoApiKey } from "CovonyxContext";
import { CovonyxProvider } from "CovonyxContext";

export const EstimatedDeliveryDatePlayground = () => {
    return (<>
        <Helmet>
            <title>Delivery Date Playground - Convert Logistics</title>
            <meta name="description" content="Customize the estimated delivery date display — destination zip, date format, colors, and templates. Then ship it with a 14-day free trial." />
        </Helmet>
        <DemoNavbar autoHide={false} />
        <main>
            <section className="section section-lg section-shaped pb-250 bg-secondary">
                {/* <BackgroundFloatingBoxes /> */}
                <Container className="py-lg-md d-flex p-lg-4">
                    <CovonyxProvider apiKey={getDemoApiKey()}>
                        <EstimatedDeliveryDateProductCardDemo />
                    </CovonyxProvider>
                </Container>
            </section>
            <section className="section section-sm">
                <Container>
                    <TrialCallout headline="Like what you built? Ship it with a free trial" />
                </Container>
            </section>
        </main>
        <br />
        <br />
        <br />
        <br />
        <CardsFooter />
    </>
    )
}